// src/utils/sessionUtils.js
import secureLocalStorage from "react-secure-storage";

export const forceLogoutAndPurge = () => {
  try {
    let rememberedEmail = "";
    try {
      rememberedEmail =
        secureLocalStorage.getItem("rememberedEmail") ||
        (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem("rememberedEmail")) ||
        secureLocalStorage.getItem("loggedInUserEmail") ||
        (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem("loggedInUserEmail")) ||
        "";
    } catch (e) {}

    // 1. Clear secure storage session keys
    secureLocalStorage.removeItem("loggedInUser");
    secureLocalStorage.removeItem("guestUser");
    secureLocalStorage.removeItem("loggedInUserEmail");
    secureLocalStorage.setItem("isLoggedOut", true);

    // 2. Clear ordinary localStorage session keys
    if (typeof window !== "undefined" && window.localStorage) {
      window.localStorage.removeItem("loggedInUser");
      window.localStorage.removeItem("guestUser");
      window.localStorage.removeItem("loggedInUserEmail");
      window.localStorage.setItem("isLoggedOut", "true");
    }

    // Always preserve rememberedEmail
    if (rememberedEmail && rememberedEmail !== "guest") {
      try {
        secureLocalStorage.setItem("rememberedEmail", rememberedEmail);
        if (typeof window !== "undefined" && window.localStorage) {
          window.localStorage.setItem("rememberedEmail", rememberedEmail);
        }
      } catch (e) {}
    }
  } catch (err) {
    console.error("Error during forceLogoutAndPurge:", err);
  }
};

export const getStoredProfilePic = (email = "") => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      if (email && email !== "guest") {
        const specific = window.localStorage.getItem(`userProfilePic_${email}`);
        if (specific) return specific;
      }
      const generic = window.localStorage.getItem("userProfilePic");
      if (generic) return generic;
    }
  } catch (e) {}
  return "";
};

export const saveStoredProfilePic = (dataUrl, email = "") => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      if (dataUrl) {
        window.localStorage.setItem("userProfilePic", dataUrl);
        if (email && email !== "guest") {
          window.localStorage.setItem(`userProfilePic_${email}`, dataUrl);
        }
      } else {
        window.localStorage.removeItem("userProfilePic");
        if (email && email !== "guest") {
          window.localStorage.removeItem(`userProfilePic_${email}`);
        }
      }
      window.dispatchEvent(
        new CustomEvent("user-profile-updated", { detail: { profilePic: dataUrl, email } })
      );
    }
  } catch (e) {}
};
